import React, { useState } from "react";
import { Link } from "react-router-dom";
import FinanceV2Layout from "./FinanceV2Layout";
import {
  SETUP_CHECKLIST,
  FEATURE_CATEGORIES,
  DAILY_WORKFLOW,
  NOT_INCLUDED,
  QUICK_ACTIONS,
} from "./financeV2FeatureGuide";
import "./FinanceV2.css";

const GUIDE_TABS = [
  { id: "start", label: "Getting started" },
  { id: "features", label: "All features" },
  { id: "workflow", label: "Daily workflow" },
  { id: "screens", label: "Where to click" },
];

export default function FinanceV2Guides() {
  const [tab, setTab] = useState("start");
  const [openCategory, setOpenCategory] = useState("foundation");

  return (
    <FinanceV2Layout>
      <div className="fv2-dashboard">
        <header className="fv2-page-header mb-2">
          <div>
            <h1 className="fv2-page-title">Guides & help</h1>
            <p className="fv2-page-sub mb-0">
              Plain-language reference for finance managers — what each part does and how numbers are
              calculated.
            </p>
          </div>
          <Link to="/finance-v2/dashboard" className="btn btn-sm btn-outline-secondary">
            Back to overview
          </Link>
        </header>

        <div className="fv2-guide-tabs mb-3">
          {GUIDE_TABS.map((t) => (
            <button
              key={t.id}
              type="button"
              className={`fv2-guide-tab ${tab === t.id ? "active" : ""}`}
              onClick={() => setTab(t.id)}
            >
              {t.label}
            </button>
          ))}
        </div>

        {tab === "start" && (
          <div className="fv2-card">
            <h5 className="fw-bold mb-3">First-time setup (7 steps)</h5>
            <p className="text-muted small">
              Complete these once before trusting reports. Each step unlocks the next part of the
              system.
            </p>
            <div className="fv2-checklist">
              {SETUP_CHECKLIST.map((item) => (
                <div key={item.step} className="fv2-checklist-item">
                  <div className="fv2-check-num">{item.step}</div>
                  <div className="flex-grow-1">
                    <div className="fw-semibold">{item.title}</div>
                    <div className="small text-muted">{item.detail}</div>
                  </div>
                  <Link to={item.path} className="btn btn-sm btn-outline-success">
                    Open
                  </Link>
                </div>
              ))}
            </div>
            <div className="mt-4 p-3 bg-light rounded">
              <strong>After setup:</strong> go to{" "}
              <Link to="/finance-v2/import">Import & sync</Link> to load historical data, then use{" "}
              <Link to="/finance-v2/dashboard">Overview</Link> for charts and{" "}
              <Link to="/finance-v2/reports">Reports</Link> for formal statements.
            </div>
          </div>
        )}

        {tab === "features" && (
          <div className="fv2-accordion">
            {FEATURE_CATEGORIES.map((cat) => (
              <div className="fv2-accordion-item" key={cat.id}>
                <button
                  type="button"
                  className={`fv2-accordion-head ${openCategory === cat.id ? "open" : ""}`}
                  onClick={() => setOpenCategory(openCategory === cat.id ? null : cat.id)}
                >
                  <span>{cat.title}</span>
                  <i className="bi bi-chevron-down" />
                </button>
                {openCategory === cat.id && (
                  <div className="fv2-accordion-body">
                    <p className="small text-muted">{cat.intro}</p>
                    <div className="table-responsive">
                      <table className="table table-sm fv2-feature-table">
                        <thead>
                          <tr>
                            <th>Feature</th>
                            <th>What it does</th>
                            <th>How to use</th>
                            <th>Automatic?</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {cat.features.map((f) => (
                            <tr key={f.name}>
                              <td className="fw-semibold">{f.name}</td>
                              <td className="small">{f.what}</td>
                              <td className="small">{f.how}</td>
                              <td className="small">{f.auto}</td>
                              <td>
                                {f.link && (
                                  <Link to={f.link} className="btn btn-sm btn-outline-success">
                                    Open
                                  </Link>
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}
              </div>
            ))}
            <div className="fv2-card mt-3 fv2-not-included">
              <h6 className="fw-bold">Not included (yet)</h6>
              <ul className="small mb-0">
                {NOT_INCLUDED.map((line, i) => (
                  <li key={i}>{line}</li>
                ))}
              </ul>
            </div>
          </div>
        )}

        {tab === "workflow" && (
          <div className="row g-3">
            {DAILY_WORKFLOW.map((block) => (
              <div className="col-md-4" key={block.when}>
                <div className="fv2-workflow-box h-100">
                  <h6 className="text-success">{block.when}</h6>
                  <ul className="small mb-0 ps-3">
                    {block.tasks.map((t, i) => (
                      <li key={i}>{t}</li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        )}

        {tab === "screens" && (
          <div className="row g-3">
            {QUICK_ACTIONS.map((a) => (
              <div className="col-md-6 col-lg-4" key={a.id}>
                <Link to={a.path} className="fv2-action-card text-decoration-none">
                  <i className={`bi ${a.icon} fv2-action-icon`} />
                  <div className="fv2-action-title">{a.title}</div>
                  <div className="fv2-action-short">{a.short}</div>
                </Link>
              </div>
            ))}
          </div>
        )}
      </div>
    </FinanceV2Layout>
  );
}
